module.exports = __webpack_public_path__ + "img/iPd-Frame.ed2ad89f.png";